import React from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ONBOARDING_STATUS_META = {
  not_started: { label: "Not Started", className: "bg-secondary" },
  lead_created: { label: "Lead Created", className: "bg-info" },
  connect_created: { label: "Connect Created", className: "bg-primary" },
  connect_sent: { label: "Connect Sent", className: "bg-dark" },
  under_review: { label: "Under Review", className: "bg-warning" },
  onboarding_in_progress: {
    label: "Onboarding In Progress",
    className: "bg-warning",
  },
  merchant_active: { label: "Merchant Active", className: "bg-success" },
  merchant_rejected: { label: "Merchant Rejected", className: "bg-danger" },
};

export const ManagerStatusBadge = ({ status }) => {
  const { t } = useTranslation();

  if (status === null || status === undefined) {
    return <span>-</span>;
  }

  return (
    <Badge bg={status === 1 ? " bg_primary" : " bg-secondary"}>
      {status === 1 ? t("Active") : t("Deactive")}
    </Badge>
  );
};

export const MerchantOnboardingBadge = ({ merchantInfo }) => {
  const { t } = useTranslation();
  const onboardingStatus = merchantInfo?.tapInfo?.onboardingStatus;

  if (!onboardingStatus) {
    return <span>-</span>;
  }

  const meta = ONBOARDING_STATUS_META[onboardingStatus] || {
    label: onboardingStatus,
    className: "bg-secondary",
  };

  return <Badge className={meta.className}>{t(meta.label)}</Badge>;
};
